import { useAtom } from 'jotai'
import { useAtomValue } from 'jotai'
import React, { createContext, useContext } from 'react'

import { useUserManagement } from '../components/hooks/useUserManagement'
import { authDataAtom, loadingUsersAtom } from '../domains/user/AtomUsers'
import { UNREADY } from '../utils/UIConstant'

const UserContext = createContext()

export function UserProvider({ children }) {
  const authData = useAtomValue(authDataAtom)
  const userManagement = useUserManagement()
  const [loadingSet, setLoadingSet] = useAtom(loadingUsersAtom)

  // 当 authData 发生变化时，重置用户上下文
  // There is a bug here, authData is keep changing, need a better way to clean up data

  React.useEffect(() => {
    if (authData === UNREADY) {
      return
    }

    userManagement.reset()
  }, [authData]) // eslint-disable-line react-hooks/exhaustive-deps

  // 基于 loadingSet 批量获取用户数据
  React.useEffect(() => {
    const fetchUsersData = async () => {
      if (loadingSet.size === 0) {
        return
      }

      await userManagement.fetchUsers({ userIds: Array.from(loadingSet) })

      setLoadingSet((prev) => {
        const next = new Set(prev)
        loadingSet.forEach((id) => next.delete(id))
        return next
      })
    }

    fetchUsersData()
  }, [loadingSet]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <UserContext.Provider
      value={{
        updateUser: userManagement.updateUser,
        fetchUser: userManagement.fetchUser,
        fetchUsers: userManagement.fetchUsers,
        fetchAllUsers: userManagement.fetchAllUsers,
        fetchInstructors: userManagement.fetchInstructors,
        initUsers: userManagement.initUsers,
        initInstructors: userManagement.initInstructors,
        reset: userManagement.reset,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useUsers = () => useContext(UserContext)
